<div class="command-palette" (keydown)="onKeydown($event)">
  <div class="command-palette__search">
    <span class="command-palette__search-icon material-symbols-outlined">search</span>
    <input
      #searchInput
      type="text"
      class="command-palette__input"
      [(ngModel)]="searchQuery"
      (input)="onSearch()"
      [placeholder]="'CommandPalette.SearchPlaceholder' | translate"
      autocomplete="off"
      spellcheck="false"
    />
    <kbd class="command-palette__kbd">ESC</kbd>
  </div>

  <div class="command-palette__results">
    @if (showSuggestions) {
      <!-- Recent Items -->
      @if (recentItems.length > 0) {
        <div class="palette__section-header">
          <span class="material-symbols-outlined">history</span>
          <span>{{ 'Label.Recent' | translate }}</span>
        </div>
        @for (item of recentItems; track item.route) {
          <button type="button" class="command-palette__item" (click)="navigateTo(item.route)">
            <span class="command-palette__item-icon material-symbols-outlined">
              {{ item.icon }}
            </span>
            <span class="command-palette__item-label">{{ item.label }}</span>
            <span class="command-palette__item-arrow material-symbols-outlined">arrow_forward</span>
          </button>
        }
      }

      <!-- Popular Commands -->
      @if (popularCommands.length > 0) {
        <div class="palette__section-header">
          <span class="material-symbols-outlined">trending_up</span>
          <span>{{ 'Label.Popular' | translate }}</span>
        </div>
        @for (cmd of popularCommands; track cmd.id) {
          <button type="button" class="command-palette__item" (click)="executeItem(cmd)">
            <span class="command-palette__item-icon material-symbols-outlined">{{ cmd.icon }}</span>
            <span class="command-palette__item-label">{{ cmd.label }}</span>
            @if (cmd.usageCount) {
              <span class="command-palette__usage-count">{{ cmd.usageCount }}</span>
            }
            <span class="command-palette__item-arrow material-symbols-outlined">arrow_forward</span>
          </button>
        }
      }

      <!-- Fallback when no recent/popular yet -->
      @if (recentItems.length === 0 && popularCommands.length === 0) {
        <div class="command-palette__empty">
          <span class="material-symbols-outlined">lightbulb</span>
          <span>{{ 'Label.TypeToSearch' | translate }}</span>
        </div>
      }
    } @else {
      <!-- Kết quả tìm THỰC THỂ THẬT (Order/HouseBill/Container/...) — FederatedSearch API,
           lọc theo quyền từng loại thực thể ở backend. Nhóm rỗng tự động không hiện. -->
      @if (loadingEntities) {
        <div class="palette__section-header command-palette__loading">
          <span class="material-symbols-outlined command-palette__loading-icon">search</span>
          <span>{{ 'CommandPalette.Searching' | translate }}</span>
        </div>
      }
      @for (group of groupedEntityResults; track group.entityType) {
        <div class="palette__section-header">
          <span>{{ 'CommandPalette.EntityTypes.' + group.entityType | translate }}</span>
        </div>
        @for (item of group.items; track item.entityId) {
          <button
            type="button"
            class="command-palette__item"
            (click)="navigateToEntityResult(item)"
          >
            <span class="command-palette__item-icon material-symbols-outlined">
              {{ item.iconHint }}
            </span>
            <span class="command-palette__item-content">
              <span class="command-palette__item-label">{{ item.title }}</span>
              @if (item.subtitle) {
                <span class="command-palette__item-subtitle">{{ item.subtitle }}</span>
              }
            </span>
            <span class="command-palette__item-arrow material-symbols-outlined">arrow_forward</span>
          </button>
        }
      }

      @if (filteredItems.length === 0) {
        @if (groupedEntityResults.length === 0 && !loadingEntities) {
          <div class="command-palette__empty">
            <span class="material-symbols-outlined">search_off</span>
            <span>{{ 'CommandPalette.NoResultsFound' | translate }}</span>
          </div>
        }
      } @else {
        @for (category of activeCategories; track category) {
          <div class="command-palette__category">
            <div class="command-palette__category-header">
              <span class="command-palette__category-icon material-symbols-outlined">
                {{ getCategoryIcon(category) }}
              </span>
              <span>{{ getCategoryLabel(category) }}</span>
            </div>
            @for (item of getItemsByCategory(category); track item.id; let i = $index) {
              <button
                type="button"
                class="command-palette__item"
                [class.command-palette__item--active]="item === filteredItems[selectedIndex]"
                (click)="executeItem(item)"
                (mouseenter)="selectedIndex = filteredItems.indexOf(item)"
              >
                <span class="command-palette__item-icon material-symbols-outlined">
                  {{ item.icon }}
                </span>
                <span class="command-palette__item-label">{{ item.label }}</span>
                @if (item.hint) {
                  <span class="command-palette__item-hint-text">{{ item.hint }}</span>
                }
                @if (item.category === 'create') {
                  <kbd class="command-palette__item-hint">
                    {{ 'CommandPalette.Create' | translate }}
                  </kbd>
                }
                <span class="command-palette__item-arrow material-symbols-outlined">
                  arrow_forward
                </span>
              </button>
            }
          </div>
        }
      }
    }
  </div>

  <div class="command-palette__footer">
    <span>
      <kbd>&uarr;&darr;</kbd>
      {{ 'CommandPalette.Navigate' | translate }}
    </span>
    <span>
      <kbd>&crarr;</kbd>
      {{ 'CommandPalette.Select' | translate }}
    </span>
    <span>
      <kbd>ESC</kbd>
      {{ 'CommandPalette.Close' | translate }}
    </span>
  </div>
</div>
